<section class="hero" id="home">

  <div class="hero-container">

    <div class="hero-content">

      <h1>
        Cuidando de quem já<br>
        cuidou de você!
      </h1>

      <p>
        Um assistente via WhatsApp para lembrar remédios,
        consultas e estar sempre por perto de quem você ama.
        Simples, carinhoso e feito para facilitar a vida dos
        idosos.
      </p>

      <a href="https://cuidazap.com/checkout" class="hero-button">
        ASSINAR AGORA
      </a>

    </div>

    <div class="hero-image">
      <img
        src="/mockup.svg"
        alt="CuidaZap no WhatsApp"
      >
    </div>

  </div>

</section>

<section class="funcionalidades" id="como-funciona">

  <div class="funcionalidades-container">

    <h2 class="funcionalidades-title">
      Conheça nossas funcionalidades
    </h2>

    <div class="funcionalidades-grid">

      <div class="funcionalidade-card">

        <img
          src="/icon-chat.svg"
          alt="Conversas e Companhia"
          class="funcionalidade-icon"
        >

        <h3>
          Conversas e Companhia<br>
          24 horas por dia
        </h3>

      </div>

      <div class="funcionalidade-card">

        <img
          src="/icon-fake.svg"
          alt="Verificador de Fake News"
          class="funcionalidade-icon"
        >

        <h3>
          Verificador de<br>
          Fake News
        </h3>

      </div>

      <div class="funcionalidade-card">

        <img
          src="/icon-boleto.svg"
          alt="Validador de Boleto"
          class="funcionalidade-icon"
        >

        <h3>
          Validador de Boleto
        </h3>

      </div>

      <div class="funcionalidade-card">

        <img
          src="/icon-hospital.svg"
          alt="Buscador de UPA e UBS"
          class="funcionalidade-icon"
        >

        <h3>
          Buscador de UPA e UBS
        </h3>

      </div>

      <div class="funcionalidade-card">

        <img
          src="/icon-lembrete.svg"
          alt="Lembrete de Remédios e Consultas"
          class="funcionalidade-icon"
        >

        <h3>
          Lembrete de Remédios e<br>
          Consultas
        </h3>

      </div>

      <div class="funcionalidade-card">

        <img
          src="/icon-fisico.svg"
          alt="Apoio em Atividades Físicas"
          class="funcionalidade-icon"
        >

        <h3>
          Apoio em Atividades<br>
          Físicas
        </h3>

      </div>

    </div>

    <a href="https://cuidazap.com/checkout" class="funcionalidades-button">
      ASSINAR AGORA
    </a>

  </div>

</section>

<section class="como-funciona" id="como-funciona">

  <div class="como-funciona-container">

    <h2 class="como-funciona-title">
      Como Funciona?
    </h2>

    <div class="passos-grid">

      <div class="passo-card">

        <div class="passo-numero">
          1
        </div>

        <h3>
          Escolha<br>
          seu plano
        </h3>

        <p>
          Escolha o plano do CuidaZap
          que melhor atende às suas
          necessidades e clique em
          “Assinar”.
        </p>

      </div>

      <div class="passo-card">

        <div class="passo-numero">
          2
        </div>

        <h3>
          Preencha<br>
          os dados
        </h3>

        <p>
          <strong>Vai contratar para outra pessoa?</strong><br>
          Nos campos destinados ao
          usuário, informe os dados do
          idoso que irá utilizar o CuidaZap.
        </p>

        <p>
          <strong>Vai contratar para você mesmo?</strong><br>
          Basta preencher os campos com
          seus próprios dados.
        </p>

      </div>

      <div class="passo-card">

        <div class="passo-numero">
          3
        </div>

        <h3>
          Confirme o<br>
          pagamento
        </h3>

        <p>
          Após preencher os dados,
          finalize a assinatura e
          realize o pagamento de
          forma segura.
        </p>

      </div>

      <div class="passo-card passo-4">

        <div class="passo-numero">
          4
        </div>

        <h3>
          Deixe o resto<br>
          com a gente
        </h3>

        <p>
          Assim que o pagamento for
          confirmado, o CuidaZap
          entrará em contato
          diretamente com o usuário
          que irá utilizar o serviço.
        </p>

        <p>
          Agora, é só aproveitar!
        </p>

      </div>

      <div class="idosos-container">

        <img
          src="/idosos.svg"
          alt="Idosos utilizando o CuidaZap"
          class="idosos-image"
        >

      </div>

    </div>

    <a href="https://cuidazap.com/checkout" class="como-funciona-button">
      ASSINAR AGORA
    </a>

  </div>

</section>

<section class="planos" id="planos">

  <div class="planos-container">

    <h2 class="planos-title">
      A nova geração do cuidado
    </h2>

    <div class="planos-grid">

      <div class="plano-card">

        <h3 class="plano-nome">
          Plano<br>
          Trimestral
        </h3>

        <div class="plano-preco">
          R$ 119,70
        </div>

        <span class="pagamento">
          Pagamento Único
        </span>

        <p class="inclui">
          O que está incluso?
        </p>

        <ul class="beneficios">

          <li>Conversas e companhia 24 horas por dia</li>

          <li>Lembretes de consultas e remédios</li>

          <li>Pedido de ajuda</li>

          <li>Verificador de Fake News</li>

          <li>Validador de Boleto</li>

          <li>Apoio na realização de atividades físicas</li>

          <li>Buscador de UPA e UBS</li>

        </ul>

        <a href="https://cuidazap.com/checkout" class="plano-button">
          ASSINAR AGORA
        </a>

      </div>

      <div class="plano-card plano-destaque">

        <h3 class="plano-nome">
          Plano<br>
          Semestral
        </h3>

        <div class="plano-preco">
          R$ 215,46
        </div>

        <span class="pagamento">
          Pagamento Único
        </span>

        <p class="inclui">
          O que está incluso?
        </p>

        <ul class="beneficios">

          <li>Conversas e companhia 24 horas por dia</li>

          <li>Lembretes de consultas e remédios</li>

          <li>Pedido de ajuda</li>

          <li>Verificador de Fake News</li>

          <li>Validador de Boleto</li>

          <li>Apoio na realização de atividades físicas</li>

          <li>Buscador de UPA e UBS</li>

        </ul>

        <a href="https://cuidazap.com/checkout" class="plano-button">
          ASSINAR AGORA
        </a>

      </div>

      <div class="plano-card">

        <h3 class="plano-nome">
          Plano<br>
          Anual
        </h3>

        <div class="plano-preco">
          R$ 335,16
        </div>

        <span class="pagamento">
          Pagamento Único
        </span>

        <p class="inclui">
          O que está incluso?
        </p>

        <ul class="beneficios">

          <li>Conversas e companhia 24 horas por dia</li>

          <li>Lembretes de consultas e remédios</li>

          <li>Pedido de ajuda</li>

          <li>Verificador de Fake News</li>

          <li>Validador de Boleto</li>

          <li>Apoio na realização de atividades físicas</li>

          <li>Buscador de UPA e UBS</li>

        </ul>

        <a href="https://cuidazap.com/checkout" class="plano-button">
          ASSINAR AGORA
        </a>

      </div>

      <div class="plano-card plano-corporativo">

        <h3 class="plano-nome">
          Plano<br>
          Corporativo
        </h3>

        <p class="corporativo-descricao">
          Uma solução completa para empresas,
          instituições e organizações que desejam
          oferecer mais cuidado e segurança
          para seus colaboradores e clientes.
        </p>

        <a
          href="https://wa.me/5511965721445?text=Ol%C3%A1!%20Gostaria%20de%20saber%20mais%20sobre%20o%20Plano%20Corporativo%20do%20CuidaZap."
          class="plano-button corporativo-button"
          target="_blank"
          rel="noopener noreferrer"
        >
          ENTRE EM CONTATO
        </a>

      </div>

    </div>

  </div>

</section>

<section class="faq-section" id="faq">
  <div class="faq-container">

    <h2>Perguntas Frequentes</h2>

    <div class="faq-list">

      <div
        class="faq-item"
        *ngFor="let item of perguntas; let i = index"
        [class.active]="perguntaAberta === i"
      >

        <button
          class="faq-question"
          type="button"
          (click)="alternarPergunta(i)"
        >

          <span class="faq-icon">
            {{ perguntaAberta === i ? '⌄' : '›' }}
          </span>

          <span>{{ item.pergunta }}</span>

        </button>

        <div
          class="faq-answer"
          *ngIf="perguntaAberta === i"
        >
          {{ item.resposta }}
        </div>

      </div>

    </div>

  </div>
</section>
